import React from "react";
import { TextField } from "@mui/material";
import { IMaskMixin } from "react-imask";

const MaskedInput = IMaskMixin(({ inputRef, ...props }) => (
  <TextField {...props} inputRef={inputRef} />
));

export default MaskedInput;
